import React, { useState, useCallback, useEffect } from 'react';
import VideoItem from '../video-item/video-item.jsx';
import rightArrow from '../../../../assets/images/consumer-theater/svg/right-arrow.svg';
import { Affix, Select, Input, Tabs, Spin, Cascader, Pagination } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import style from './consumer-library.module.scss';
import videoPlayIcon from '../../../../assets/images/consumer-theater/svg/play-btn.svg';
import arrowIcon from '../../../../assets/images/consumer-theater/svg/arrow.svg';
import arrowIconDisabled from '../../../../assets/images/consumer-theater/svg/arrow-disabled.svg';
import { fetchCategory, getListByTopic, fetchList, fetchInsight } from '../../api/request.js';
import videoPosterDemo from '../../../../assets/images/consumer-theater/video-poster-demo2.png';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { dialShare } from '../../../../components/icons/icons.jsx';
import LZString from '../../../../util/lz-string.js';
import appendQueryParams from '../../../../util/search-append.js';
import ShareModal from '../../../../components/share-modal/share-modal.jsx';
import { useAskGpt } from '../../../consumer-theater-chat/hooks/useAskGPT.jsx';

function debounce (callback, delay) {
  let lastTime;
  return function () {
    clearTimeout(lastTime);
    const [that, args] = [this, arguments];
    lastTime = setTimeout(() => {
      callback.apply(that, args);
    }, delay);
  };
}

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 30,
      color: '#00FF00'
    }}
    spin
  />
);

const { Search } = Input;

let requestIndex = 0;
let topicDetailRequestIndex = 0; 
let scaleRate = 1;

function ConsumerLibrary({country, toLibrary, play, show, LifeStageOptions, DietaryOptions, AgeOptions, IncomeOptions, GeographicOptions }) {

  const [scaleStyle, setScaleStyle] = useState(null);
  const [headerHeight, setHeaderHeight] = useState(90);
  const [contentHeight, setContentHeight] = useState('auto');

  let timer = null;
  const scaleComputed = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      const winWidth = document.documentElement.clientWidth - 134;
      let rate = 1;
      if (winWidth > 1482) {
        rate = 1;
      } else {
        rate = winWidth/1482;
      }
      scaleRate = rate;
      setScaleStyle({
        left: '50%',
        transformOrigin: 'center 0',
        transform: `translateX(-50%) scale(${scaleRate})`
      });
      setHeaderHeight(90*scaleRate);
      heightComputed();
    }, 16);
  };

  const heightComputed = () => {
    if (scaleRate === 1) {
      setContentHeight('auto');
      return;
    }
    const height = document.querySelector('#pageMainContentChild').offsetHeight;
    const heightPx = height * scaleRate + 'px';
    setContentHeight(heightPx);
  };

  useEffect(() => {
    window.addEventListener('resize', scaleComputed);
    scaleComputed();
    return () => {
      window.removeEventListener('resize', scaleComputed);
    };
  }, []);
  
  const [loading, setLoading] = useState(false);

  // LifeStage
  const [lifeStageValue, setLifeStageValue] = useState([]);
  
  // Dietary
  const [dietaryValue, setDietaryValue] = useState([]);

  // Age
  const [ageValue, setAgeValue] = useState([]);

  // Income  socialClass
  const [incomeValue, setIncomeValue] = useState([]);

  // Geographic
  const [geographicValue, setGeographicValue] = useState([]);

  // ??????
  useEffect(() => {
    if (country.country) {
      // ??????????filter
      setLifeStageValue([]);
      setDietaryValue([]);
      setAgeValue([]);
      setIncomeValue([]);
      setGeographicValue([[country.region, country.country]]);
      setCurrentTab('--all--');
      setIsHomeTour(false);
    } else {
      // ?????????
    }
  }, [country]);

  const maxTagPlaceholder = (val) => {
    return `+${val.length}`;
  };

  // tags ??
  const [selectedTags, setSelectedTags] = useState([]);
  const onTagSelect = (tag) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter(item => item !== tag));
    } else {
      const arr = [...selectedTags, tag];
      setSelectedTags(arr);
    }
  };

  // search
  const [searchDefaultValue, setSearchDefaultValue] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const searchChange = (val) => {
    setSearchDefaultValue(val);
  };
  const onSearch = (val) => {
    setSearchValue(val);
    let geographicReq = [];
    let countryReq = [];
    geographicValue.forEach(item => {
      if (item.length === 1) {
        geographicReq.push(item[0]);
      } else {
        countryReq.push(item[1]);
      }
    });
    geographicReq = [...new Set(geographicReq)];
    GeographicOptions.forEach(region => {
      if (geographicReq.includes(region.value)) {
        countryReq.push(...region.children.map(item => item.value));
      }
    });
    countryReq = [...new Set(countryReq)];
    const params = {
      country: countryReq,
      lifeStage: isHomeTour ? null : lifeStageValue,
      dietary: isHomeTour ? null : dietaryValue,
      age: isHomeTour ? null : ageValue,
      socialClass: incomeValue,
      // geographic: geographicReq,
      category: currentTab === '--all--' ? null : currentTab,
      search: val
    };
    requestIndex++;
    if (detailTopic) {
      setCurrent(1);
      params.topic = detailTopic.topic;
      params.page = 1;
      params.page_size = pageSize;
      params.tag = selectedTags;
      delayFetchTopicDetailList(params);
    } else {
      delayFetchTopicList(params);
    }
  };

  const location = useLocation();
  useEffect(() => {
    // ??search??
    const queryParams = new URLSearchParams(location.search);
    const queryToken = queryParams.get('queryToken');
    if (!queryToken) return;
    let params = {};
    try {
      const paramsStr = LZString.decompressFromEncodedURIComponent(queryToken);
      params = JSON.parse(paramsStr);
    } catch (error) {
      console.error('URL parse error: ', error);
    }
    let showLibrary = false;
    Object.keys(params).forEach(key => {
      if (params[key].length > 0) {
        showLibrary = true;
      }
      if (key === 'lifeStageValue') {
        setLifeStageValue(params.lifeStageValue);
      } else if (key === 'dietaryValue') {
        setDietaryValue(params.dietaryValue);
      } else if (key === 'ageValue') {
        setAgeValue(params.ageValue);
      } else if (key === 'incomeValue') {
        setIncomeValue(params.incomeValue);
      } else if (key === 'geographicValue') {
        setGeographicValue(params.geographicValue);
      } else if (key === 'searchValue') {
        setSearchValue(params.searchValue);
        setSearchDefaultValue(params.searchValue);
      } else if (key === 'currentTab') {
        setCurrentTab(params.currentTab);
      }  else if (key === 'detailTopic') {
        setDetailTopic(params.detailTopic);
      }
    });
    if (showLibrary) {
      toLibrary();
    }
    console.log(params);
  }, [location]);

  const [showShare, setShowShare] = useState(false);
  const [shareUrl, setShareUrl] = useState('');

  const shareHandle = () => {
    const params = {
      lifeStageValue,
      dietaryValue,
      ageValue,
      incomeValue,
      geographicValue,
      searchValue,
      currentTab
    };
    if (detailTopic) {
      params.detailTopic = {
        topic_id: detailTopic.topic_id,
        topic: detailTopic.topic,
        data: []
      };
    }
    const paramsStr = JSON.stringify(params);
    const LZSStr = LZString.compressToEncodedURIComponent(paramsStr);
    const shareUrl = appendQueryParams(window.location.href, {queryToken: LZSStr});
    setShareUrl(shareUrl);
    setShowShare(true);
  };

  // tab ?? home tour 
  const [isHomeTour, setIsHomeTour] = useState(false);

  const toolCom = (
    <div className={style.toolGroupBox}>
      <div className={style.selectGroup}>
        {!isHomeTour && 
          <>
            <div className={style.inputBorder}>
              <Select
                mode="multiple"
                placeholder='LifeStage'
                allowClear
                maxTagCount={1}
                maxTagTextLength={lifeStageValue.length > 1 ? 2 : 8}
                maxTagPlaceholder={maxTagPlaceholder}
                value={lifeStageValue}
                onChange={(newValue) => {
                  setLifeStageValue(newValue);
                }}
                options={LifeStageOptions}
                showSearch
                popupMatchSelectWidth={false}
              />
            </div>
            <div className={style.inputBorder}>
              <Select
                mode="multiple"
                placeholder='Dietary'
                allowClear
                maxTagCount={1}
                maxTagTextLength={dietaryValue.length > 1 ? 2 : 8}
                maxTagPlaceholder={maxTagPlaceholder}
                value={dietaryValue}
                onChange={(newValue) => {
                  setDietaryValue(newValue);
                }}
                options={DietaryOptions}
                showSearch
                popupMatchSelectWidth={false}
              />
            </div>
            <div className={style.inputBorder}>
              <Select
                mode="multiple"
                placeholder='Age'
                allowClear
                maxTagCount={1}
                maxTagTextLength={ageValue.length > 1 ? 2 : 8}
                maxTagPlaceholder={maxTagPlaceholder}
                value={ageValue}
                onChange={(newValue) => {
                  setAgeValue(newValue);
                }}
                options={AgeOptions}
                showSearch
                popupMatchSelectWidth={false}
              />
            </div>
          </>
        }
        <div className={style.inputBorder}>
          <Select
            mode="multiple"
            placeholder='Social Class'
            allowClear
            maxTagCount={1}
            maxTagTextLength={incomeValue.length > 1 ? 2 : 8}
            maxTagPlaceholder={maxTagPlaceholder}
            value={incomeValue}
            onChange={(newValue) => {
              setIncomeValue(newValue);
            }}
            options={IncomeOptions}
            showSearch
            popupMatchSelectWidth={false}
          />
        </div>
        <div className={style.inputBorder}>
          <Cascader
            placeholder="Geographic"
            multiple
            maxTagCount={1}
            maxTagTextLength={geographicValue.length > 1 ? 2 : 8}
            maxTagPlaceholder={maxTagPlaceholder}
            value={geographicValue}
            onChange={setGeographicValue}
            options={GeographicOptions}
            showSearch
          />
        </div>
      </div>
      <div className={style.searchBox}>
        <Search
          className={style.mySearch}
          placeholder="Search"
          value={searchDefaultValue}
          onChange={e => searchChange(e.target.value)}
          onSearch={onSearch}
          style={{ width: 260 }}
        />
        <div className={style.shareBox} onClick={() => shareHandle()}>
          <img src={dialShare} alt="" />
        </div>
      </div>
    </div>
  );

  // tabs
  const [tabList, setTabList] = useState([]);
  const [currentTab, setCurrentTab] = useState('--all--');
  useEffect(() => {
    fetchCategory()
      .then(res => {
        const tabs = [
          {
            key: '--all--',
            label: 'All Topic'
          }
        ];
        res?.data?.forEach(item => {
          tabs.push({
            ...item,
            key: item.title,
            label: item.title
          });
        });
        tabs.sort((a, b) => a.label.localeCompare(b.label));
        setTabList(tabs);
      })
      .catch(error => console.error(error));
  }, []);
  const onTabClick = (key) => {
    setCurrentTab(key);
    setDetailTopic(null);
    setSelectedTags([]);
    setTopicDetailVideos([]);
    const winHeight = document.documentElement.clientHeight;
    window.scrollTo({
      top: winHeight + 11,
      behavior: 'instant'
    });
  };
  const onChange = (key) => {
    if (key === 'Home Tour') {
      setIsHomeTour(true);
    } else {
      setIsHomeTour(false);
    }
    setCurrentTab(key);
    setDetailTopic(null);
    setSelectedTags([]);
    setTopicDetailVideos([]);
  };
  const showSubjectDetail = (topic) => {
    setTopicList([]);
    setDetailTopic(topic);
  };

  const [detailTopic, setDetailTopic] = useState(null);

  const [topicList, setTopicList] = useState([]);
  const fetchData = (params) => {
    setLoading(true);
    heightComputed();
    return getListByTopic({...params, sort: 'title'}, requestIndex)
      .then(res => {
        if (requestIndex !== res.config.uuid) return;
        setTopicList(Array.isArray(res.data.data) ? res.data.data.map((item, index) => {
          return {
            ...item,
            uuid:`${Date.now()}-${index}`
          };
        }) : []);
        setLoading(false);
      })
      .catch(error => {
        if (requestIndex !== error?.config?.uuid) return;
        setLoading(false);
      })
      .finally(() => {
        setTimeout(() => {
          heightComputed();
        }, 0);
      });
  };
  const delayFetchTopicList = useCallback(debounce(function(val) { return fetchData(val);}, 500), []);
  useEffect(() => {
    if (!show || detailTopic) return;
    let geographicReq = [];
    let countryReq = [];
    geographicValue.forEach(item => {
      if (item.length === 1) {
        geographicReq.push(item[0]);
      } else {
        countryReq.push(item[1]);
      }
    });
    geographicReq = [...new Set(geographicReq)];
    GeographicOptions.forEach(region => {
      if (geographicReq.includes(region.value)) {
        countryReq.push(...region.children.map(item => item.value));
      }
    });
    countryReq = [...new Set(countryReq)];
    const params = {
      country: countryReq,
      lifeStage: isHomeTour ? null : lifeStageValue,
      dietary: isHomeTour ? null : dietaryValue,
      age: isHomeTour ? null : ageValue,
      socialClass: incomeValue,
      // geographic: geographicReq,
      category: currentTab === '--all--' ? null : currentTab,
      search: searchValue
    };
    requestIndex++;
    delayFetchTopicList(params);
  }, [show, detailTopic, lifeStageValue, dietaryValue, ageValue, incomeValue, geographicValue, currentTab, searchValue, isHomeTour]);

  const fillBox = (length) => {
    const res = [];
    for (let i = 0; i < 4-length; i++) {
      res.push(<div className={style.videoItemBox} key={i}></div>);
    }
    return res;
  };

  function getCountry(geographicValue) {
    let geographicReq = [];
    let countryReq = [];
    geographicValue.forEach(item => {
      if (item.length === 1) {
        geographicReq.push(item[0]);
      } else {
        countryReq.push(item[1]);
      }
    });
    geographicReq = [...new Set(geographicReq)];
    GeographicOptions.forEach(region => {
      if (geographicReq.includes(region.value)) {
        countryReq.push(...region.children.map(item => item.value));
      }
    });
    countryReq = [...new Set(countryReq)];
    return countryReq;
  }

  // topic detail
  const [topicDetailAll, setTopicDetailAllList] = useState([]);
  const [topicDetailTotal, setTopicDetailTotal] = useState(0);
  const [topicDetailCurrent, setTopicDetailCurrent] = useState(1);
  const [topicDetailIntro, setTopicDetailIntro] = useState(null);
  const [topicDetailVideos, setTopicDetailVideos] = useState(null);
  const [total, setTotal] = useState(0);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [preBtnDisabled, setPreBtnDisabled] = useState(false);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(false);

  const setCurrentDetail = (index) => {
    if (index < 1) {
      index = 1;
    }
    if (topicDetailAll.length && index > topicDetailAll.length) {
      index = topicDetailAll.length;
    }
    setTopicDetailCurrent(index);
    setTopicDetailIntro(topicDetailAll[index - 1] ? topicDetailAll[index - 1] : null);
    if (index === 1) {
      setPreBtnDisabled(true);
    } else {
      setPreBtnDisabled(false);
    }
    if (index === topicDetailAll.length) {
      setNextBtnDisabled(true);
    } else {
      setNextBtnDisabled(false);
    }
    if (selectedTags.length) setSelectedTags([]);
  };

  const preDetail = () => {
    if (topicDetailCurrent <= 1) return;
    setCurrentDetail(topicDetailCurrent-1);
  };

  const nextDetail = () => {
    if (topicDetailCurrent >= topicDetailTotal) return;
    setCurrentDetail(topicDetailCurrent+1);
  };

  useEffect(() => {
    if (!detailTopic) return;
    const countries = getCountry(geographicValue);
    const resList = topicDetailAll;
    for (let i = 0; i < countries.length; i++) {
      const index = resList.findIndex(item => item.country === countries[i]);
      if(index > -1) {
        setCurrentDetail(index+1);
        break;
      }
    }
  }, [geographicValue, topicDetailAll]);

  // ??topic??
  useEffect(() => {
    if (!show || !detailTopic) return;
    setCurrentDetail(1);
    setTopicDetailAllList([]);
    setTopicDetailTotal(0);
    setTopicDetailVideos([]);
    fetchInsight({topic: detailTopic.topic, topic_id: detailTopic.topic_id}, topicDetailRequestIndex)
      .then(res => {
        if (topicDetailRequestIndex !== res.config.uuid || !detailTopic) return;
        const resData = res.data.data;
        const resList = Array.isArray(resData) ? resData.filter(item => item.insight) : [];
        setCurrentDetail(1);
        setTopicDetailAllList(resList);
        setTopicDetailTotal(resList.length);
        setTopicDetailIntro(resList.length ? resList[0] : null);
      })
      .catch(error => {
        console.log(error);
      });
  }, [detailTopic]);

  const fetchTopicDetailData = (params) => {
    setLoading(true);
    heightComputed();
    return fetchList({...params, sort: 'title'}, requestIndex)
      .then(res => {
        if (requestIndex !== res.config.uuid) return;
        setTopicDetailVideos(Array.isArray(res.data.data) ? res.data.data : []);
        setTotal(res.data.total);
        setCurrent(res.data.current);
        setPageSize(res.data.size);
        setLoading(false);
      })
      .catch(error => {
        if (requestIndex !== error?.config?.uuid) return;
        setLoading(false);
      })
      .finally(() => {
        setTimeout(() => {
          heightComputed();
        }, 0);
      });
  };
  const delayFetchTopicDetailList = useCallback(debounce(function(val) { return fetchTopicDetailData(val);}, 500), []);
  useEffect(() => {
    if (!show || !detailTopic) return;
    let geographicReq = [];
    let countryReq = [];
    geographicValue.forEach(item => {
      if (item.length === 1) {
        geographicReq.push(item[0]);
      } else {
        countryReq.push(item[1]);
      }
    });
    geographicReq = [...new Set(geographicReq)];
    GeographicOptions.forEach(region => {
      if (geographicReq.includes(region.value)) {
        countryReq.push(...region.children.map(item => item.value));
      }
    });
    countryReq = [...new Set(countryReq)];
    const params = {
      country: countryReq,
      lifeStage: isHomeTour ? null : lifeStageValue,
      dietary: isHomeTour ? null : dietaryValue,
      age: isHomeTour ? null : ageValue,
      socialClass: incomeValue,
      // geographic: geographicReq,
      category: currentTab === '--all--' ? null : currentTab,
      search: searchValue,
      topic: detailTopic.topic,
      page: current,
      page_size: pageSize,
      tag: selectedTags
    };
    requestIndex++;
    delayFetchTopicDetailList(params);
  }, [show, detailTopic, current, pageSize, lifeStageValue, dietaryValue, ageValue, incomeValue, geographicValue, currentTab, searchValue, isHomeTour, selectedTags]);

  // ASK GTP
  const { setFilterByCT } = useAskGpt();
  useEffect(() => {
    const countries = getCountry(geographicValue);
    const params = {
      lifeStage: lifeStageValue,
      dietary: dietaryValue,
      age: ageValue,
      socialClass: incomeValue,
      country: countries,
      category: currentTab === '--all--' ? null : [currentTab],
      search: searchValue,
      topic: detailTopic?.topic ? [detailTopic?.topic] : null
    };
    setFilterByCT(params);
  }, [lifeStageValue, dietaryValue, ageValue, incomeValue, geographicValue, currentTab, searchValue, detailTopic]);

  return (
    <div className={style.pageContainer}>
      <Affix>
        <div>
          <div className={style.resizeHeaderBox} style={{height: headerHeight + 'px'}}>
            <div className={style.headerBox} style={scaleStyle}>
              <div className={style.headerTitle}>Library</div>
              <div className={style.headerToolBox}>{toolCom}</div>
            </div>
          </div>
          <div className={style.tabContainer}>
            <div className={style.topicGroupBox}>
              <Tabs activeKey={currentTab} items={tabList} onChange={onChange} onTabClick={onTabClick} />
            </div>
          </div>
        </div>
      </Affix>
      <div className={style.pageMainContent} style={{height: contentHeight}}>
        {loading &&
          <div className={style.loadingBox}>
            <Spin indicator={antIcon}>
              <div className={style.subBox}></div>
            </Spin>
          </div>
        }
        {/* topic list */}
        {!detailTopic && <div id="pageMainContentChild" className={style.subjectList} style={scaleStyle}>
          {topicList?.length===0 && <div className={style.noData}>Coming Soon</div>}
          {
            topicList?.length > 0 && topicList.map(topic => {
              return (
                <div key={topic.uuid} className={style.subjectItem}>
                  <div className={style.subjectItemName} onClick={() => showSubjectDetail(topic)}>{topic.topic}</div>
                  <div className={style.subjectItemVideos}>
                    { topic?.data?.map(item => {
                      return <VideoItem onClick={() => play(item, topic.data)} originData={item} key={item.id} title={item.title} info={item.transcription} />;
                    })}
                    {
                      fillBox(topic?.data?.length).map(item => item)
                    }
                  </div>
                  <div className={style.subjectItemInto}>
                    <img className={style.rightArrow} src={rightArrow} alt="" onClick={() => showSubjectDetail(topic)} />
                  </div>
                </div>
              );
            })
          }
        </div>}
        {/* topic detail */}
        {detailTopic && 
        <div id="pageMainContentChild" className={style.subjectDetail} style={scaleStyle}>
          <div className={style.titleBox}>
            <div>{detailTopic.topic}</div>
            {/* {topicDetailIntro && <div className={style.countryBox}>
              <span className={style.countryLabel}>Country:</span>
              <span className={style.countryName}>{topicDetailIntro.country ? topicDetailIntro.country : 'General'}</span>
            </div>} */}
          </div>
          {topicDetailIntro ? 
            <>
              <div className={style.infoBox}>
                {/* { topicDetailTotal > 1 && <>
                  <div className={style.preBtn} onClick={preDetail}>
                    {preBtnDisabled && <img className={style.arrowSvgDisabled} src={arrowIconDisabled} alt="" />}
                    {!preBtnDisabled && <img className={style.arrowSvg} src={arrowIcon} alt="" />}
                  </div>
                  <div className={style.nextBtn} onClick={nextDetail}>
                    {nextBtnDisabled && <img className={style.arrowSvgDisabled} src={arrowIconDisabled} alt="" />}
                    {!nextBtnDisabled && <img className={style.arrowSvg} src={arrowIcon} alt="" />}
                  </div>
                </>} */}
                <div className={style.topVideo} onClick={() => play({...topicDetailIntro, transcription: topicDetailIntro.insight})}>
                  <img className={style.videoPoster} src={topicDetailIntro.image_url || videoPosterDemo} alt="" />
                  { topicDetailIntro.video_url && <img className={style.videoPlayButtonIcon} src={videoPlayIcon} alt="" />}
                </div>
                <div className={style.infoRight}>
                  <div className={style.infoText}>{topicDetailIntro.insight}</div>
                  <div className={style.labelBox}>
                    {topicDetailIntro?.tags?.map((item, index) => {
                      return <div key={index} className={classNames(style.labelItem, {[style.labelSelected]: selectedTags.includes(item)})} onClick={() => onTagSelect(item)}>{item}</div>;
                    })}
                  </div>
                </div>
              </div>
              {/* {topicDetailTotal > 1 && <div className={style.detailPagination}>
                <Pagination 
                  onChange={(page) => setCurrentDetail(page)} 
                  total={topicDetailTotal}
                  pageSize={1} 
                  current={topicDetailCurrent} 
                />
              </div>} */}
            </> : <div className={style.noDataInsight }>Coming Soon</div>}
          <div className={style.allVideos}>
            <div className={style.allVideosTitleBox}>All video</div>
            {topicDetailVideos?.length===0 && <div className={style.noData}>Coming Soon</div>}
            {topicDetailVideos?.length > 0 && <><div className={style.videoContainer}>
              <div className={style.videoWrapper}>
                { topicDetailVideos?.map(item => {
                  return (
                    <div key={item.id} className={style.videoItemContainer}>
                      <VideoItem onClick={() => play(item, topicDetailVideos)} originData={item} key={item.id} title={item.title} info={item.transcription} />
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={style.paginationBox}>
              <Pagination
                onChange={(page) => setCurrent(page)}
                onShowSizeChange={(_, size) => {setCurrent(1);setPageSize(size);}}
                total={total}
                current={current}
                pageSize={pageSize} 
                showSizeChanger={true} 
                pageSizeOptions={[1, 10, 20, 30, 40]} 
                showQuickJumper={true} 
              />
            </div></>}
          </div>
        </div>}
      </div>
      {showShare ? <ShareModal cardURL={shareUrl} onClose={() => setShowShare(false)} /> : null}
    </div>
  );
}

export default ConsumerLibrary;